<script>
	import { createEventDispatcher, onMount } from 'svelte';

	const dispatch = createEventDispatcher();

	let username;
	let password;
	let rememberMe = true;
	let invalid;

	async function checkLogin() {
		if (!username || !password) {
			invalid = true;
			return;
		}

		await fetch('https://ostium.ch/api/borsalino/authenticate.php', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json;charset=utf-8'
			},
			body: JSON.stringify({ username: username, password: password })
		}).then(result => {
			if (result.ok) {
				console.log('Logged in successfully.');
				username = '';
				password = '';
				invalid = false;
				dispatch('login', {
					token: result.text(),
					rememberMe: rememberMe
				});
			} else {
				invalid = true;
				console.warn('Could not login.', result.statusText);
			}
		});
	}

	onMount(() => {
		jQuery('#username').focus();
	});
</script>

<div class="container-fluid">
	<div class="row pt-5">
		<div class="col-xl-6 col-lg-9 col-12">
			<form>
				<div class="form-group row">
					<label for="username" class="col-md-3 col-form-label text-nowrap">Username/E-mail</label>
					<div class="col-md-9">
						<input type="email" class="{'form-control ' + (invalid ? 'is-invalid' : '')}" id="username" bind:value={username} on:input="{() => invalid = false}" required>
					</div>
				</div>
				<div class="form-group row">
					<label for="password" class="col-md-3 col-form-label">Password</label>
					<div class="col-md-9">
						<input type="password" class="{'form-control ' + (invalid ? 'is-invalid' : '')}" id="password" bind:value={password} on:input="{() => invalid = false}" required>
						<div class="invalid-feedback">
							Username or password is wrong!
						</div>
					</div>
				</div>
				<div class="form-group row">
					<div class="col-md-3"></div>
					<div class="col-md-9 form-check">
						<input class="form-check-input ml-0" type="checkbox" id="rememberMe" bind:checked={rememberMe}>
						<label class="form-check-label ml-4" for="rememberMe">Remember me</label>
					</div>
				</div>
				<button type="submit" class="btn btn-primary" on:click|preventDefault={checkLogin}>Login</button>
			</form>
		</div>
	</div>
</div>
